import css from 'styled-jsx/css';

export default css`
  .brands__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 1em;
  }
  .brands__container > div {
    padding-bottom: 20px;
  }
  .brands__header {
    padding: 25px;
    margin-bottom: 20px;
    background-color: var(--bg-wrapper-info);
  }
  .letter {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 700;
    border-bottom: var(--line);
    padding: 8px;
    background: var(--background-subheader);
  }
  .brands-list {
    cursor: pointer;
    padding: 8px;
    transition: 0.3s;
    font-weight: 400;
  }
  .brands-list:hover {
    text-decoration: underline;
  }
  @media only screen and (min-width: 768px) {
    .brands__container > div {
      padding-bottom: 40px;
    }
    .brands__header {
      padding: 40px;
    }
  }
`;
